

import React, { useEffect, useState ,useRef} from "react";
import { Box, Drawer, IconButton, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";



const FilterDrawer = ({ open, onClose, filters, setFilters, onApplyFilters }) => {
  const { t } = useTranslation();
  const [localFilters, setLocalFilters] = useState(filters);
const statusOptions = [
  { key: "assigned", label: t("taskStatus.assigned"), value: "assigned" },
  { key: "inprogress",label: t("taskStatus.inprogress"), value: "in_progress" },
  { key: "completed", label: t("taskStatus.completed"), value: "completed" },
 
];
  useEffect(() => {
    if (open) setLocalFilters(filters);
  }, [open, filters]);

  const apply = () => {
      console.log("🔹 Filter selected in drawer (before API):", localFilters);

    onApplyFilters(localFilters);
    onClose();
  };

  const clear = () => {
    const cleared = { status: "", startDate: "", endDate: "" };
    setLocalFilters(cleared);
    onApplyFilters(cleared);
    onClose();
  };
    const startRef = useRef(null);
  const endRef = useRef(null);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 400, md: 550 }, backgroundColor: "#E7EBEE" } }}
    >
      <Box sx={{ position: "sticky", top: 0, backgroundColor: "#E7EBEE", zIndex: 10, px: 2, py: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <IconButton onClick={onClose}>
            <img src={profilecross} alt="close" />
          </IconButton>
          <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
            {t("filterDrawer.filterTask") || "Filter Tasks"}
          </CustomText>
        </Box>
      </Box>

      <Box sx={{ px: 2 }}>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            px: 3,
            py: 3,
            height: "calc(100vh - 90px)",
            overflowY: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          {/* Status Filter */}
          <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, color: "#2C384C", textAlign: "left", pt: 3 }}>
            {t("filterDrawer.status") || "Status"}
          </CustomText>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
            {statusOptions.map((opt) => {
              const isSelected = localFilters.status === opt.value;
              return (
                <Button
                  key={opt.key}
                  variant="outlined"
                  size="small"
                  onClick={() =>
                    setLocalFilters((prev) => ({
                      ...prev,
                      status: isSelected ? "" : opt.value,
                    }))
                  }
                  sx={{
                    borderRadius: "6px",
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    py: 0.8,
                    px: 2,
                    color: isSelected ? "#006EC2" : "#363333",
                    border: isSelected ? "2px solid #006EC2" : "2px solid #091E4224",
                    backgroundColor: "transparent",
                  }}
                >
                  {opt.label}
                </Button>
              );
            })}
          </Box>

          {/* Date From */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("filterDrawer.startDate") || "Start Date"}</label>
            <input
               ref={startRef}
    onClick={() => startRef.current?.showPicker()}
              type="date"
              value={localFilters.startDate || ""}
              onChange={(e) => setLocalFilters((prev) => ({ ...prev, startDate: e.target.value }))}
              className="project_input"
              style={{ width: "100%", height: 40 }}
            />
          </Box>

          {/* Date To */}
          <Box sx={{ mt: 3 }}>
            <label className="field_label">{t("filterDrawer.endDate") || "End Date"}</label>
            <input
               ref={endRef}
    onClick={() => endRef.current?.showPicker()}
              type="date"
              value={localFilters.endDate || ""}
              onChange={(e) => setLocalFilters((prev) => ({ ...prev, endDate: e.target.value }))}
              className="project_input"
              style={{ width: "100%", height: 40 }}
            />
          </Box>

          {/* Buttons */}
          <Box sx={{ mt: 4, display: "flex", flexWrap: "wrap", gap: 2 }}>
            <CustomButton
              onClick={apply}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" style={{ width: 16, height: 16 }} />
                  {t("filterDrawer.apply") || "Apply"}
                </Box>
              }
              size="medium"
            />
            <Button
              variant="outlined"
              onClick={clear}
              sx={{
                fontSize: 15,
                textTransform: "none",
                borderRadius: "5px",
                fontFamily: "Poppins, sans-serif",
                color: "#006EC2",
                border: "2px solid #006EC2",
                px: 3,
                py: 1,
                height: "fit-content",
              }}
            >
              {t("filterDrawer.clear") || "Clear"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
